/** Global keyboard capture for the race. Returns a detach function. */
export function attachTyping(onKey: (key: string) => void): () => void {
  const handler = (e: KeyboardEvent) => {
    const t = e.target as HTMLElement | null;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (e.key === 'Backspace' || e.key === 'Tab' || e.key === 'Escape') {
      e.preventDefault();
      onKey(e.key);
    } else if (e.key.length === 1) {
      e.preventDefault();
      onKey(e.key);
    }
  };
  const block = (e: Event) => e.preventDefault();
  addEventListener('keydown', handler);
  addEventListener('paste', block);
  addEventListener('drop', block);
  return () => {
    removeEventListener('keydown', handler);
    removeEventListener('paste', block);
    removeEventListener('drop', block);
  };
}
